import React, { useEffect, useMemo, useCallback } from "react";
import ReactDOMServer from "react-dom/server";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { IconSensor } from "pages/SensorList/components/SensorDetailHeader";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./MiniMap.css";
import { retrieveListScenarioFromSensor } from "../helpers";
import { generateScenarioIcon } from "utils/helper";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

const MapUpdater = ({ containerRef }) => {
  const map = useMap();
  useEffect(() => {
    if (!containerRef.current) return;
    const resizeObserver = new ResizeObserver(() => {
      map.invalidateSize();
    });
    resizeObserver.observe(containerRef.current);
    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }
    };
  }, [map, containerRef]);
  return null;
};

const MiniMapView = React.forwardRef(({ center, zoom = 15, popupText, targetGroup, currentSensor }, ref) => {
  
  const createScenarioIcon = useCallback((scenario) => {
    const iconHeight = scenario.type === 'VEHICLE' ? 65 : 75;
    return L.divIcon({
      html: ReactDOMServer.renderToString(
        <div style={{ 
          width: '40px', 
          height: `${iconHeight}px`, 
          transform: `rotate(${scenario.rotation}deg)`,
          transformOrigin: 'center bottom'
        }}>
          <img 
            src={generateScenarioIcon(scenario.color, scenario.numberOrder)} 
            alt={scenario.name}
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'contain'
            }} 
          />
        </div>
      ),
      className: "custom-scenario-icon",
      iconSize: [40, iconHeight],
      iconAnchor: [20, iconHeight],
      popupAnchor: [0, -iconHeight],
    });
  }, []);

  // const additionalMarkers = useMemo(() => {
  //   if (!currentSensor) return [];
  //   if (!currentSensor.data.trafficVolumeFeature) return [];
  //   const scenarios = retrieveListScenarioFromSensor(currentSensor);
  //   if (scenarios.length === 0) return [];

  //   return scenarios.map((scenario, index) => ({
  //     id: `${currentSensor.id}-scenario-${index}-${scenario.lat}-${scenario.lng}`,
  //     position: { lat: scenario.lat, lng: scenario.lng },
  //     icon: createScenarioIcon(scenario),
  //     popup: `シナリオ${scenario.numberOrder}, タイプ: ${scenario.type}`,
  //   }));
  // }, [currentSensor, createScenarioIcon]);

  const markerIcon = useMemo(() => {
    if (targetGroup && currentSensor) {
      return L.divIcon({
        html: ReactDOMServer.renderToString(
          <IconSensor
            position='map'
            color={targetGroup?.messages?.[currentSensor.status]?.color || "#0A3D71"}
            type={targetGroup?.type}
            sensor={currentSensor}
          />
        ),
        className: "custom-leaflet-icon",
        iconSize: [30, 30],
        iconAnchor: [54, 80],
        popupAnchor: [0, -30],
      });
    }
    return new L.Icon.Default();
  }, [targetGroup, currentSensor]);

  if (!center || typeof center.lat !== "number" || typeof center.lng !== "number") {
    return <div>Invalid coordinates or loading...</div>;
  }

  return (
    <div className="mini-map-container" ref={ref}>
      <MapContainer center={center} zoom={zoom} scrollWheelZoom={true} dragging={true} zoomControl={false} doubleClickZoom={true} style={{ height: "100%", width: "100%" }}>
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        
        {/* Main marker */}
        <Marker position={center} icon={markerIcon}>
          <Popup>{popupText}</Popup>
        </Marker>

        {/* Additional markers - optimized with stable keys */}
        {/* {additionalMarkers.map((marker) => (
          <Marker 
            key={marker.id}
            position={marker.position} 
            icon={marker.icon}
          > */}
            {/* {marker.popup && <Popup>{marker.popup}</Popup>} */}
          {/* </Marker>
        ))} */}
        
        <MapUpdater containerRef={ref} />
      </MapContainer>
    </div>
  );
});

export default MiniMapView;
